module.exports = __webpack_public_path__ + "51c243950a07372f8cdd7539a032f74e.png";